import React, { FC } from 'react';
import { Button } from 'antd';
import { Text } from 'components/text/Text';
import { PaymentMethodWrapper } from './common';
import { useDispatch } from 'react-redux';
import { paymentSlice } from 'logic/store/payment/payment.slice';
import { translate, translationKeys } from 'logic/translations/translations.service';

export const AddPaymentMethod: FC = () => {
  const dispatch = useDispatch();
  const handleOnClick = () => {
    dispatch(paymentSlice.actions.openAddPaymentMethodModal());
  };

  return (
    <PaymentMethodWrapper>
      <Button type={'primary'} ghost onClick={handleOnClick}>
        <Text color={'primary'}>
          {translate(translationKeys.tutoringInstituteProfile.paymentsPage.addPaymentMethodCTA)}
        </Text>
      </Button>
    </PaymentMethodWrapper>
  );
};
